import { Action } from 'redux';

export const GET_CUSTOM_REPORT_ALL = 'report-all/GET_CUSTOM_REPORT_ALL';
export const getCustomReportAll = () => ({
  type: GET_CUSTOM_REPORT_ALL,
});

export const SET_CUSTOM_REPORT_ALL = 'report-all/SET_CUSTOM_REPORT_ALL';
export const setCustomReportAll = (data: ReadonlyArray<CustomLookupResult>) => ({
  type: SET_CUSTOM_REPORT_ALL,
  payload: data,
});
// check citation enabled
export const GET_CHECK_CITATION_ENABLED = 'report-all/GET_CHECK_CITATION_ENABLED';
export const getCheckCitationEnabled = () => ({
  type: GET_CHECK_CITATION_ENABLED,
});

export const SET_CHECK_CITATION_ENABLED = 'report-all/SET_CHECK_CITATION_ENABLED';
export const setCCheckCitationEnabled = (data: ReadonlyArray<CustomLookupResult>) => ({
  type: SET_CHECK_CITATION_ENABLED,
  payload: data,
});
// check citation enabled end

export const GET_CUSTOM_LOOKUP_RUN = 'report-all/GET_CUSTOM_LOOKUP_RUN';
export const getCustomLookupRun = (data: { readonly name: string }) => ({
  type: GET_CUSTOM_LOOKUP_RUN,
  payload: data,
});

export const SET_CUSTOM_LOOKUP_RUN = 'report-all/SET_CUSTOM_LOOKUP_RUN';
export const setCustomLookupRun = (data: CustomLookupRun) => ({
  type: SET_CUSTOM_LOOKUP_RUN,
  payload: data,
});
export const RESET_CUSTOM_LOOKUP_RUN = 'report-all/RESET_CUSTOM_LOOKUP_RUN';
export const resetCustomLookupRun = () => ({
  type: RESET_CUSTOM_LOOKUP_RUN,
});

export interface SetCustomReportsAllAction extends Action<typeof SET_CUSTOM_REPORT_ALL> {
  readonly payload: ReadonlyArray<CustomLookupResult>;
}
export interface SetCheckCitationEnabledAction extends Action<typeof SET_CHECK_CITATION_ENABLED> {
  readonly payload: any;
}
export interface SetCustomLookupRunAction extends Action<typeof SET_CUSTOM_LOOKUP_RUN> {
  readonly payload: CustomLookupRun;
}

export interface ResetCustomLookupRunAction extends Action<typeof RESET_CUSTOM_LOOKUP_RUN> {}

export type ReportAllAction =
  SetCustomReportsAllAction | SetCustomLookupRunAction | ResetCustomLookupRunAction | SetCheckCitationEnabledAction;
